module.exports = __webpack_public_path__ + "media/35.0c07e780.mp3";